import { useEffect, useState } from 'react';
import axios from 'axios';

const apiUrl = "https://elcobradorleague.com/api";

export const useLeaderboard = (idleague) => {
  const [divisions, setDivisions] = useState([]);

  useEffect(() => {
    if (!idleague) return; // Evita llamadas si no hay idleague

    axios.get(`${apiUrl}/api.php?endpoint=leaderboard`)
      .then(res => {
        const data = res.data;
        if (data && typeof data === 'object') {
          const formatted = Object.entries(data).map(([key, players]) => {
            const filteredPlayers = players.filter(p => p.idleague === idleague);
            const divisionName = filteredPlayers[0]?.divisionname ?? key;
            return {
              division: divisionName,
              players: filteredPlayers
            };
          }).filter(div => div.players.length > 0);
          setDivisions(formatted);
        } else {
          setDivisions([]);
        }
      })
      .catch(() => setDivisions([]));
  }, [idleague]);

  return { divisions };
};